export enum REGIONS {
  US = 'US', // USA
  CA = 'CA', // Canada
  DE = 'DE', // Germany
  GB = 'GB', // Great Britain / UK
  CH = 'CH', // Switzerland
  ZA = 'ZA', // South Africa
}

export enum LANGUAGES {
  en = 'en', // english
  fr = 'fr', // french
  de = 'de', // german
  it = 'it', // italian
}

export enum DOMAINS {
  com = '.com',
  ca = '.ca',
  ch = '.ch',
  de = '.de',
  uk = '.co.uk',
  za = '.co.za',
}

export enum MONEY_FORMAT {
  de_ch = 'CHF',
  en_us = '$US',
  en_ca = '$CA',
  en_ch = 'CHF',
  en_gb = 'GB£',
  fr_ca = 'CA$',
  fr_ch = 'CHF',
  it_ch = 'CHF',
  en_za = 'ZAR',
  en_de = '€EU',
  de_de = '€EU',
}

export enum CURRENCY_CODE_FORMAT {
  de_ch = 'CHF',
  en_us = 'USD',
  en_ca = 'CAD',
  en_ch = 'CHF',
  en_gb = 'GBP',
  fr_ca = 'CAD',
  fr_ch = 'CHF',
  it_ch = 'CHF',
  en_za = 'ZAR',
  de_de = 'EUR',
  en_de = 'EUR',
}

export enum LOCALES {
  en_ca = 'en-CA',
  en_ch = 'en-CH',
  en_de = 'en-DE',
  en_gb = 'en-GB',
  en_us = 'en-US',
  en_za = 'en-ZA',
  de_ch = 'de-CH',
  de_de = 'de-DE',
  fr_ca = 'fr-CA',
  fr_ch = 'fr-CH',
  it_ch = 'it-CH',
}

export type LocaleData = {
  code: LOCALES;
  region: REGIONS;
  language: LANGUAGES;
  moneyFormat?: MONEY_FORMAT;
  currencyCodeFormat?: CURRENCY_CODE_FORMAT;
};

export const CURRENCY_PREFIX = {
  [LOCALES.de_ch]: 'CHF',
  [LOCALES.en_us]: '$',
  [LOCALES.en_ca]: '$',
  [LOCALES.en_ch]: 'CHF',
  [LOCALES.en_gb]: '£',
  [LOCALES.fr_ca]: '$',
  [LOCALES.fr_ch]: 'CHF',
  [LOCALES.it_ch]: 'CHF',
  [LOCALES.en_za]: 'ZAR',
  [LOCALES.en_de]: '€',
  [LOCALES.de_de]: '€',
};
